export default __webpack_public_path__ + "images/banner-girl-1.24e9b8f48d5a0ac32680edd194503695.png";